import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

import Box from "@material-ui/core/Box";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { adjective as proAdjective } from "@language/provider";
import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";

const { BRAND_NAME } = process.env;

const ContentBadgeDialog = ({ close, open }) => {
	const classes = useStyles("Content");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	return (
		<Dialog
			scroll="paper"
			fullScreen={fullScreen}
			fullWidth={true}
			maxWidth={"sm"}
			open={open}
			onClose={close}
			aria-labelledby="editorial integrity"
			aria-describedby="editorial integrity"
		>
			<DialogTitle disableTypography style={{ minHeight: 50 }}>
				<Box position={"absolute"} top={6} right={6}>
					<IconButton aria-label="close" onClick={close}>
						<CloseIcon />
					</IconButton>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Box mb={12}>
					<Box display="flex" alignItems="center" pb={4}>
						<LogoIcon width={30} height="100%" />
						<Box
							ml={3}
							fontWeight={700}
							lineHeight={1.4}
							fontSize={{ xs: 22, sm: 24 }}
						>
							Our editorial integrity
						</Box>
					</Box>

					<p className={classes.asideSubText}>
						{`${BRAND_NAME} follows a strict editorial policy, so you can trust that we’re putting your interests first. All of our content is authored and edited by subject matter experts, who ensure everything we publish is objective, accurate, and trustworthy.`}
					</p>

					<div className={classes.asideSubHeader}>Our Standards</div>

					<p className={classes.asideSubText}>
						{`We value your trust. Our mission is to provide readers with unique, accurate, and unbiased information, and we have editorial standards in place to ensure that happens. ${BRAND_NAME} works directly with thousands of expert ${proAdjective.plural} to gather proprietary data and research. Our editors thoroughly fact-check this content to ensure accuracy.`}
					</p>

					<p className={classes.asideSubText}>
						{`So, whether you’re reading an article or a review, you can trust that you’re getting credible, dependable, and first-hand information.`}
					</p>

					<div className={classes.asideSubHeader}>Our Mission</div>

					<p className={classes.asideSubText}>
						{`${BRAND_NAME}’s editorial team writes for YOU—the reader. Our mission is to give you the best information and resources to help you complete your goals.`}
					</p>

					<p className={classes.asideSubText}>
						{`We know that providing quality content is just the beginning. For the next step in your journey, we’re here to help you hire trusted professionals and services. ${BRAND_NAME} has built a dependable network of vetted ${proAdjective.plural} to make hiring and completing your goals easy.`}
					</p>

					<div className={classes.asideSubHeader}>Data Use Policy</div>

					<p className={classes.asideSubText}>
						{`Our data use policy is simple—you can use our proprietary data and images by including a link back to our site.`}
					</p>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

ContentBadgeDialog.propTypes = {};
export default ContentBadgeDialog;
